import { gql } from '@apollo/client';

const GET_PRODUCTS = gql`
  query products($params: QueryParams, $name: String) {
    products(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
        description
        type
        variants {
          id
          title
          img
          description
          price
          isPrimaryVariant
          product {
            id
            name
            description
          }
        }
      }     
    }
  }
`;

const UPDATE_CATEGORY = gql`
  mutation updateCategory($id: ID!, $category: CategoryUpdateInput!, $productCategories: [ID]) {
    updateCategory(id: $id, category: $category, productCategories: $productCategories) {
     id  
    }
  }
`;

export { GET_PRODUCTS, UPDATE_CATEGORY }
